module.exports = __webpack_public_path__ + "media/img/event/logo/kuas-923f9940326fb38ed2efdc9f8fdaf7af.jpg";